import React from 'react';
import * as d3 from 'd3';
import ChartComponent from './ChartComponent';

const XAxis = ({ xScale, height }) => {
    function draw(chart) {
        chart.attr('class', 'Axis__x')
            .attr('transform', `translate(0, ${height})`)
            .call(d3.axisBottom(xScale));
    }

    return (
        <ChartComponent
            draw={(chart) => {
                draw(chart);
            }}
        />
    )
}

export default XAxis
